const makeColorObj = (
	textColor: string,
	borderColor: string,
	bgColor: string
) => ({
	textColor,
	borderColor,
	bgColor,
});

export const cssVar = (varName: string) => "var(--" + varName + ")";

export const colors = {
	primary: makeColorObj(
		cssVar("blue-lightest"),
		cssVar("blue-dark"),
		cssVar("blue")
	),
	secondary: makeColorObj(
		cssVar("grey-lightest"),
		cssVar("grey-dark"),
		cssVar("grey")
	),
	success: makeColorObj(
		cssVar("green-light"),
		cssVar("green-dark"),
		cssVar("green")
	),
	info: makeColorObj(cssVar("teal-light"), cssVar("teal-dark"), cssVar("teal")),
	warning: makeColorObj(
		cssVar("orange-light"),
		cssVar("orange-dark"),
		cssVar("orange")
	),
	danger: makeColorObj(cssVar("red-light"), cssVar("red-dark"), cssVar("red")),
	// light: "white",
	// dark: "darkgray",
};
export type ColorVariant = keyof typeof colors;
// type ColorVariantShade = keyof ReturnType<typeof makeColorObj>;
